import api from '@/services/api';
import { Charge } from '@/types/charge';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { chargeKeys } from './use-charges';
import { enrollmentKeys } from './use-enrollments';

/**
 * "Passar para automático" (PLANO-RECEBIMENTO-AUTOMATICO.md, 4.6, T2.4/T6.3):
 * converte uma cobrança manual em aberto para automática, um clique por vez.
 * A API decide sozinha a elegibilidade (`resolveProcessingMethod`) e devolve
 * 400 `CHARGE_NOT_ELIGIBLE_FOR_AUTOMATIC` com mensagem pronta quando não dá —
 * quem chama trata isso com `getApiErrorMessage`.
 */
export function useConvertToAutomatic() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (chargeId: string) => {
      const response = await api.post<Charge>(`/charge/${chargeId}/convert-to-automatic`);
      return response.data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: chargeKeys.all });
      if (data?.id) {
        queryClient.invalidateQueries({ queryKey: chargeKeys.detail(data.id) });
      }
      if (data?.enrollmentId) {
        queryClient.invalidateQueries({
          queryKey: chargeKeys.byEnrollment(data.enrollmentId),
        });
        queryClient.invalidateQueries({
          queryKey: enrollmentKeys.detail(data.enrollmentId),
        });
        queryClient.invalidateQueries({ queryKey: enrollmentKeys.provider() });
      }
    },
  });
}
